import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import React from 'react';
import c from 'classnames';
import { Section } from '@wix/da-a11y/pkg/components/headings/tagWrappers';
import s from './WidgetBoxWrapper.scss';
export const WidgetBoxWrapper = /*#__PURE__*/ React.forwardRef((_param, ref)=>{
    var { className, id, children } = _param, props = _object_without_properties(_param, [
        "className",
        "id",
        "children"
    ]);
    return /*#__PURE__*/ React.createElement(Section, _object_spread({
        id: id,
        className: c(s['root'], className),
        ref: ref
    }, props), children);
});
WidgetBoxWrapper.displayName = 'WidgetBoxWrapper';
export default WidgetBoxWrapper;
